import React, {useEffect, useState} from "react"
import {UserAuthService} from "../../../../services/user-auth-api.service";
import PrivacyPolicySkeleton from "../../../skeletons/setting/PrivacyPolicySkeleton";


export default function TermsAndConditionSetting() {
    const [pagesData,setPagesData] = useState()
    const [loader , setLoader] = useState(true)

    async function GetPages () {
        setLoader(true)
        const response = await UserAuthService.GetPages('terms')
        if(response?.data?.data?.status) {
            setPagesData(response?.data?.data?.data?.result?.rawHtml)
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetPages()
    },[])

    if(loader){
        return <PrivacyPolicySkeleton/>
    }

    return(
        <div className={'policy'}>
            <h6 className={'setting-heading mb-3'}>Terms & Conditions</h6>
            <div dangerouslySetInnerHTML={{ __html: pagesData }} />
        </div>
    )
}